import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { DownloadOutlined } from "@ant-design/icons";

const ExportButton = ({
  id = "btn-export",
  title,
  type = "default",
  onClick = () => {},
  icon = <DownloadOutlined />,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.export");

  return (
    <Button
      className={`hover:opacity-70 ${className}`}
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(ExportButton);
